import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { Modal, Button, Avatar, Tooltip } from 'antd';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { setStateUserEnter } from 'app/actions/Users/user.enter.action';
import { UserOutlined } from '@ant-design/icons';
import {
  loginModalOpen,
  loginIsLogin,
} from '../../../actions/Login/login.action';
import LoginStateMachine from '../UserEnter/loginStateMachine';

import './sign.css';
import { DataLoginProps } from '../../PropType/propTypesLoginData';

import { userActions } from '../../../actions/Users/user.sign.action';
import { fixHttps } from '../../Utility/coreFunctions';
// IMAGE
import { START_LOGIN } from '../../../constants/enter.user.constants';
import userAPI from '../../../API/user.service.api';
import NotificationComponent from './notification';

import Mark from '../../Utility/Mark/mark';

import { getUserLink } from '../../Utility/utility';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isConfirmed: false,
      notificationData: [],
    };
  }

  showModal = () => {
    this.props.loginModalChange(true);
  };

  logout = () => {
    this.props.isLoginChange(false);
    this.props.loginModalChange(false);
  };

  onClose = () => {
    this.props.isLoginChange(false);
    this.props.loginModalChange(false);
    this.props.setStateUserEnter({ name: START_LOGIN });
  };

  logoutRender = () => {
    const { modalOpen } = this.props.dataLogin;
    return (
      <div className="mainMenuUserLogin">
        <Button className="btn" onClick={this.showModal}>
          <span>
            <FormattedMessage id="Login" defaultMessage="Login" />
          </span>
        </Button>
        <Modal
          closable
          visible={modalOpen}
          footer={false}
          width={355}
          style={{ top: 200 }}
          className="loginDesctop"
          onCancel={this.onClose}
        >
          <LoginStateMachine />
        </Modal>
      </div>
    );
  };

  fixHttps = (link) => {
    if (link && link.length !== 0 && link.indexOf('http') !== -1) {
      return link.replace(/^http:\/\//i, 'https://');
    }
    return link;
  };

  loginRender = () => {
    const { notificationData } = this.state;
    const {
      userData,
      router,
      user_history = {},
      userHistoryReducer,
    } = this.props;
    const { main_page = {} } = user_history;
    const { name, id } = userData;
    return (
      <div className="mainMenuUserLoginIn">
        <NotificationComponent
          data={notificationData}
          getNotificationData={this.getNotificationData}
          router={router}
        />
        <Tooltip
          title={<FormattedMessage id="Profile" defaultMessage="Profile" />}
          placement="bottom"
        >
          <Link to={getUserLink({ name, id })} style={{ zIndex: 10 }}>
            <Mark
              show={
                userHistoryReducer.fetched &&
                main_page.show === undefined &&
                main_page.show !== 0
              }
              left
            >
              <Avatar
                src={
                  userData && userData.avatar ? fixHttps(userData.avatar) : ''
                }
                size={35}
                alt="img"
                icon={<UserOutlined />}
              />
            </Mark>
          </Link>
        </Tooltip>
      </div>
    );
  };

  requestFinished = () => {
    this.setState({ isConfirmed: true });
  };

  componentDidMount() {
    this.props.autologin(this.requestFinished);
  }

  getNotificationData = () => {
    userAPI
      .getNotification()
      .then((res) => {
        const { code, response } = res;
        if (code === 200) {
          this.setState({
            notificationData: response.data,
          });
        }
      })
      .catch((err) => console.log(err));
  };

  setNotificationData = (data) => {
    this.setState({
      notificationData: data,
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.isLoggedIn !== this.props.isLoggedIn) {
      if (this.props.isLoggedIn) {
        this.getNotificationData();
      } else {
        this.setNotificationData([]);
      }
    }
    if (
      prevProps.router.location !== this.props.router.location &&
      this.props.isLoggedIn === true
    ) {
      setTimeout(() => {
        this.getNotificationData();
      }, 1000);
    }
  }

  render() {
    const { isLoggedIn } = this.props;
    if (isLoggedIn) {
      return this.loginRender();
    }
    if (this.state.isConfirmed) {
      return isLoggedIn ? this.loginRender() : this.logoutRender();
    }
    return '';
  }
}

Login.displayName = 'Sign-up_Login';
Login.propTypes = {
  dataLogin: PropTypes.shape(DataLoginProps),
  isLoginChange: PropTypes.func,
  loginModalChange: PropTypes.func,
  setStateUserEnter: PropTypes.func,
};

const mapStateToProps = (store) => {
  const { isLoggedIn } = store.authentication;
  return {
    dataLogin: store.loginData,
    isLoggedIn,
    userData: store.authentication.user,
    router: store.router,
    userHistoryReducer: store.userHistoryReducer,
    user_history: store.userHistoryReducer.data.user_history,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      loginModalChange: loginModalOpen,
      isLoginChange: loginIsLogin,
      logout: userActions.logout,
      autologin: userActions.autologin,
      setStateUserEnter,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(Login);
